export var BetStatus;
(function (BetStatus) {
    BetStatus[BetStatus["INVALID"] = 0] = "INVALID";
    BetStatus[BetStatus["ACTIVE"] = 1] = "ACTIVE";
    BetStatus[BetStatus["WON"] = 2] = "WON";
    BetStatus[BetStatus["LOST"] = 3] = "LOST";
    BetStatus[BetStatus["RETURNED"] = 4] = "RETURNED";
    BetStatus[BetStatus["PUSH"] = 5] = "PUSH";
    BetStatus[BetStatus["TIE"] = 6] = "TIE";
})(BetStatus || (BetStatus = {}));
